// extracted by css-extract-rspack-plugin
export default {"toasts":"dNNjnz"};